import { NgClass, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { BullhornFieldType } from '../../data-rules-model';
import { IActionFieldMeta } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';

@Component({
  selector: 'app-action-prepend',
  templateUrl: './prepend.component.html',
  imports: [
    NgSwitch,
    NgClass,
    ReactiveFormsModule,
    NgSwitchDefault,
    NgSwitchCase,
    MatTooltip
  ],
  styleUrls: ['../action.component.scss']
})
export class PrependComponent extends BaseActionComponent implements AfterViewInit {

  truncWarningToolTip = 'Note: Depending on the max length of the field,'
    + ' length of the current string and the length of the string to be prepended, the result string may be truncated.  ';

  ngAfterViewInit() {
    if (!this.valueControl.value && isNaN(this.valueControl.value)) {
      this.valueControl.setValue(PrependComponent.getDefaultValue(this.destinationTypeControl.value));
    }

    this.valueControl.valueChanges.subscribe(value => this.valueControlValueChange());
    this.valueControlValueChange();

    setTimeout(() => {
      this.getMeta(this.destinationDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {
          const selField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
          this.sourceControl.setValidators(null);
          this.destinationControl.setValidators(Validators.required);
          this.destinationControlValueChange(selField);
        });
    }, 0);
  }

  protected destinationControlValueChange(selectedField: IActionFieldMeta): void {

    if (!selectedField) {
      this.valueControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      return;
    }

    if (this.destinationTypeControl.value !== selectedField.metaType)
      this.valueControl.setValue(PrependComponent.getDefaultValue(selectedField.metaType));

    this.valueControl.setValidators(
      selectedField.metaType === BullhornFieldType.STRING
        ? null
        : Validators.required
    );

    this.destinationTypeControl.setValue(selectedField.metaType);
  }

  private static getDefaultValue(type: string): any {
    switch (type) {
      case 'STRING':
        return '';
      default:
        return null;
    }
  }

  private valueControlValueChange(): void {
    // TODO redundant logic is just updated with Paired Entities update
    this.getMeta(this.destinationDescriptorControl.value)
      .subscribe((filteredMeta: IActionFieldMeta[]) => {
        const dstField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
      });

    if(this.valueControl.value === null || this.valueControl.value.trimStart().length === 0) {
      this.valueControl.setErrors({invalid:true})
    }
  }
}
